import messageJson from '@/assets/message.json'
import LinkTextFile from '@/components/atoms/LinkTextFile.vue'

const FcMessage = {
  install (Vue, options) {
    var messageList = []
    const findMessage = (id) => {
      var msg = messageJson[id]
      if (!msg) {
        msg = { message: id, box: 'alert', type: 'info', command: 'OK' }
      }
      return msg
    }
    const messageFormat = (msg, ...params) => {
      var result = msg.message
      const paramList = params.map((x, i) => { return { index: i, value: x } }).filter(x => (x.value ?? '') !== '')
      result = paramList.reduce((acc, cur) => acc.replace('{' + cur.index + '}', cur.value), result)
      if (msg.empty_hidden && Array.isArray(msg.empty_hidden)) {
        msg.empty_hidden.forEach(hiddenWord => { result = result.replace(hiddenWord, '') })
      }
      result = result.replace(/\{\d+\}/g, '')
      return result
    }
    const messageBox = async (title, id, ...params) => {
      const msg = findMessage(id)
      var msgBox = Vue.prototype.$alert
      if (msg.box === 'confirm') {
        msgBox = Vue.prototype.$confirm
      }
      return await msgBox(messageFormat(msg, ...params), title, {
        confirmButtonText: msg.command.includes('Yes') ? 'はい' : 'OK',
        cancelButtonText: msg.command.includes('No') ? 'いいえ' : 'Cancel',
        type: msg.type
      }).then(() => {
        return Promise.resolve(true)
      }).catch(() => {
        return Promise.resolve(false)
      })
    }
    const getMessage = (id, ...params) => {
      const msg = findMessage(id)
      return messageFormat(msg, ...params)
    }
    const showMessage = (...args) => {
      const createMessage = (item, close) => {
        const msg = findMessage(item.id)

        const msgParam = {}
        const message = messageFormat(msg, ...(item.params ?? []))
        if (!item.link) {
          msgParam.message = message
        } else {
          const Dummy = Vue.component('dummy', {})
          const c = new Dummy()
          const h = c.$createElement
          const error = item.link.messages.map(x => getMessage(x.id, ...(x.params ?? []))).join('\r\n') + '\r\n'
          const link = h(LinkTextFile, {
            props: {
              fileName: item.link.fileName,
              fileData: error
            },
            on: {
              export: () => {
                msgParam.close()
              }
            }
          }, '[' + item.link.fileName + ']')
          msgParam.message = h('p', {
            class: {
              'el-message__content': true
            }
          }, [message, '詳細は', link, 'を参照ください。'])
        }
        msgParam.type = msg.type
        msgParam.onClose = (v) => {
          messageList = [...messageList.filter(i => i !== v)]
          messageList.forEach((v, i) => {
            v.verticalOffset = 20 + (8 + v.height) * i
          })
        }
        if (close) {
          msgParam.showClose = close
          msgParam.duration = 0
        }
        if (messageList.length > 0) {
          const lastMsg = messageList.slice(-1)[0]
          msgParam.offset = lastMsg.verticalOffset + 8 + lastMsg.height
        } else {
          msgParam.offset = 20
        }

        const v = Vue.prototype.$message(msgParam)
        messageList.push(v)
        v.verticalOffset = v.offset
        v.height = parseInt(getComputedStyle(v.$el).borderTopWidth) +
            parseInt(getComputedStyle(v.$el).paddingTop) +
            parseInt(getComputedStyle(v.$el).fontSize) +
            parseInt(getComputedStyle(v.$el).paddingBottom) +
            parseInt(getComputedStyle(v.$el).borderBottomWidth)
        msgParam.close = () => {
          v.close()
        }
      }
      const [item, showClose, ...params] = args
      const type = Object.prototype.toString.call(item)
      switch (type) {
        case '[object Array]':
          item.forEach((x) => {
            createMessage(x, showClose)
          })
          break
        case '[object Object]':
          createMessage(item, showClose)
          break
        default:
          createMessage({ id: item, params: params }, showClose)
      }
    }
    Vue.prototype.$fcMessage = {
      messageBox,
      getMessage,
      showMessage
    }
  }
}
export default FcMessage
